export default "__VITE_ASSET__8269bbb4__"